module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "page-header"
    }
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "md",
      "type": "inverse fixed-top"
    }
  }, [_c('b-navbar-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.title.menu')))]), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "href": "#"
    }
  }, [_c('h1', {
    staticClass: "navbar-brand"
  }, [_c('span', {
    staticClass: "foobar-logo"
  }, [_vm._v("Foo")]), _c('span', [_vm._v("Bar")]), _c('span', {
    staticClass: "foobar-logo"
  }, [_vm._v("Beer")])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-navbar-nav', [_c('b-nav-item', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#page-header'),
      expression: "'#page-header'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.title.main.home')))])]), _vm._v(" "), _c('b-nav-item', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#page-search'),
      expression: "'#page-search'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.title.main.search')))])]), _vm._v(" "), _c('b-nav-item', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#page-news'),
      expression: "'#page-news'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.title.main.news')))])]), _vm._v(" "), _c('b-nav-item', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#page-social-links'),
      expression: "'#page-social-links'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.title.main.social')))])]), _vm._v(" "), _c('b-nav-item', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#footer'),
      expression: "'#footer'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.title.main.contacts')))])])], 1), _vm._v(" "), _c('b-navbar-nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.auth.editor),
      expression: "$store.state.auth.editor"
    }],
    staticClass: "ml-auto"
  }, [_c('b-nav-item', {
    attrs: {
      "href": "#"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/add-foobar"
    }
  }, [_c('icon', {
    attrs: {
      "name": "plus"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.title.main.add')))], 1)], 1)], 1), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-item', {
    attrs: {
      "href": "#"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/foobars"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.title.main.foobars')))])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f101ed0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Header.vue
// module id = 1844
// module chunks = 1